import DetailsCard from '../details-card/DetailsCard'

import type { DetailsCardProps } from '@/components/details-card/DetailsCard'

export default function DetailsGrid({
  items,
  gridClass,
  roundedImages = true,
}: {
  items: DetailsCardProps[]
  gridClass?: string
  roundedImages?: boolean
}) {
  // Bail if no items
  if (!items || !items.length) {
    return null
  }

  gridClass = !gridClass ? 'flex flex-col gap-s' : gridClass

  return (
    <div className="component">
      <div className="container">
        <div className={gridClass}>
          {items?.map((item, index) => {
            return (
              <DetailsCard
                key={index}
                image={item?.image}
                title={item?.title}
                subtitle={item?.subtitle}
                text={item?.text}
                link={item?.link}
                roundedImages={roundedImages}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}
